import React from "react";

const blogs = [
  {
    img: "/images/keyword/1.jpg",
    title: "Mumbai to Goa Cabs",
    date: "Shambhu Cabs provides a smooth and reliable Mumbai to Goa cab service for long-distance travel. Enjoy a safe, comfortable ride with well-maintained cars and experienced drivers, making your coastal journey easy, convenient, and completely hassle-free",
    link: "/mumbai-to-goa-cabs"
  },
  {
    img: "/images/keyword/5.jpg",
    title: "Mumbai to Pune Cab",
    date: "Shambhu Cabs offers fast, safe, and reliable Mumbai to Pune cab services for business trips, family travel, or airport transfers. Enjoy comfortable rides with trained drivers, clean vehicles, and on-time pickups for a smooth journey between the two cities",
    link: "/mumbai-to-pune-cab"
  },
  {
    img: "/images/keyword/10.jpg",
    title: "Mumbai to Lonavala Cab",
    date: "Experience a relaxing hill-station journey with Shambhu Cabs’ Mumbai to Lonavala cab service. Our skilled drivers and comfortable cars ensure a safe, convenient, and enjoyable ride, perfect for weekend getaways, sightseeing, or family trips",
    link: "/mumbai-to-lonavala-cab"
  },
  {
    img: "/images/keyword/3.jpg",
    title: "Mumbai to Nashik Cab",
    date: "Shambhu Cabs provides reliable Mumbai to Nashik cab services for business, tourism, or personal travel. Travel comfortably in well-maintained vehicles with professional drivers, ensuring timely arrivals and a safe, enjoyable journey",
    link: "/mumbai-nashik-cab"
  },
  {
    img: "/images/keyword/2.jpg",
    title: "Mumbai to Shirdi Cab",
    date: "Experience hassle-free travel from Mumbai to Shirdi with Shambhu Cabs. Our services offer safe, comfortable rides with experienced drivers and well-maintained cars, making your pilgrimage or leisure trip convenient and stress-free",
    link: "/mumbai-to-shirdi-cab"
  },
  {
    img: "/images/keyword/4.jpg",
    title: "Mumbai to Kolhapur Cab",
    date: "Shambhu Cabs offers dependable Mumbai to Kolhapur cab services for business trips, family visits, or sightseeing. Enjoy a smooth and comfortable journey in clean, well-maintained cars with skilled and professional drivers",
    link: "/mumbai-to-kolhapur-cab"
  }
];


const BlogArea = () => {
  return (
    <section className="blog-section">
      <div className="container">
        
        <div className="heading">
          <h4>Latest</h4>
          <h2>Our Blog</h2>
        </div>

        <div className="blog-grid">
          {blogs.map((blog, index) => (
            <div className="blog-card" key={index}>
              
              <a href={blog.link}>
                <img src={blog.img} alt={blog.title} className="blog-img" />
              </a>

              <div className="blog-content">
                <h3 className="blog-title">
                  <a href={blog.link}>{blog.title}</a>
                </h3>

                <p className="blog-desc">{blog.date}</p>

                <a href={blog.link} className="read-more-btn">
                  Read More →
                </a>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BlogArea;
